// Shared frontend constants — eliminate magic numbers across pages.

// Network timeouts (ms)
export const LLM_REQUEST_TIMEOUT_MS = 90_000; // Vision / audio ingest calls to Claude/Whisper
export const BRIEFING_REQUEST_TIMEOUT_MS = 60_000; // Daily briefing LLM call
export const VOICE_REQUEST_TIMEOUT_MS = 60_000; // Chat voice transcription

// Time-of-day thresholds (hour, 24h)
export const HOUR_AFTERNOON_START = 12;
export const HOUR_EVENING_START = 19;

// File-size limits
export const BYTES_PER_KB = 1024;
export const MAX_AUDIO_SIZE_BYTES = 24 * 1024 * 1024; // 24 MB — matches backend cap
export const MAX_IMAGE_SIZE_BYTES = 8 * 1024 * 1024; // 8 MB — matches backend cap
